import { Edit, VideoLibrary } from "@mui/icons-material";
import React, { ReactElement } from "react";

import {
  PresentationType,
  RenderingObjectKind,
} from "../../generated/gql/graphql";
import useLocale from "../../hooks/use-locale";
import useUser from "../../hooks/use-user";
import { CanvasObject } from "../../types/canvas-object";
//import AiBackgroundEditorButton from "../button/ai-background-editor-button";
import { Size } from "../../types/size";
import SpanPackshotButton, {
  SpanPackshotButtonProps,
} from "../button/span-packshot-button";
import IconTooltip from "../icons/icon-tooltip";

export type CanvasPanelHeaderProps = {
  title: string;

  selectedCanvasObject: CanvasObject | undefined;
  selectedCanvasObjectChange: SpanPackshotButtonProps["canvasObjectChange"];
  backgroundId?: string;
  canvasObjects?: CanvasObject[];

  canvasSize: Size;
};

export default function CanvasPanelHeader(
  props: CanvasPanelHeaderProps,
): ReactElement {
  const {
    title,
    selectedCanvasObject,
    //backgroundId,
    selectedCanvasObjectChange,
    //canvasObjects,
    canvasSize,
  } = props;
  const { data: userData } = useUser();

  const { getText } = useLocale();

  return (
    <div className="border-b-1 flex items-center justify-between space-x-5 border-companyDarkGrey px-5 py-5">
      <p className="font-bold uppercase text-companyMediumGrey">{title}</p>
      <div className="flex flex-row items-center space-x-5">
        {/* <AiBackgroundEditorButton
          backgroundId={backgroundId}
          canvasObjects={canvasObjects}
        /> */}
        <SpanPackshotButton
          canvasSize={canvasSize}
          canvasObject={selectedCanvasObject}
          canvasObjectChange={selectedCanvasObjectChange}
        />
        {userData?.me?.activeClient?.canAdaptLabel && (
          <IconTooltip
            icon={<Edit />}
            activeTooltip={getText(
              "sections.canvas.header.adaptIndicator.tooltip.active",
            )}
            inactiveTooltip={getText(
              "sections.canvas.header.adaptIndicator.tooltip.inactive",
            )}
            active={
              selectedCanvasObject &&
              selectedCanvasObject.kind === RenderingObjectKind.Presentation &&
              !!selectedCanvasObject.productInputs &&
              selectedCanvasObject.productInputs.length > 0
            }
          />
        )}
        <IconTooltip
          icon={<VideoLibrary />}
          activeTooltip={getText(
            "sections.canvas.header.animationIndicator.tooltip.active",
          )}
          inactiveTooltip={getText(
            "sections.canvas.header.animationIndicator.tooltip.inactive",
          )}
          active={
            selectedCanvasObject?.kind === RenderingObjectKind.Presentation &&
            selectedCanvasObject.presentation?.type ===
              PresentationType.Animation
          }
        />
      </div>
    </div>
  );
}
